export default __webpack_public_path__ + "static/media/NGORealCase2-moblie.11bb56bf.jpg";